<template>
  <div class="content">
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3>{{lesson.coursetitle}}. {{lesson.stagetitle}}. {{lesson.title}}</h3>
          <h5>Lesson date and time: {{lesson.lessondatestr}}, Duration: {{lesson.duration}} minutes</h5>
          <h5>Teacher: {{lesson.teachername}} ({{lesson.teacherphone}}, {{lesson.teacheremail}})</h5>
          <table>
            <tr><td><h5>Location: {{lesson.locationtype ? lesson.locationtype === 1 ? lesson.locationtypename : lesson.locationtypename + ": " + lesson.location : "N/A"}}</h5></td><td style="padding-left: 10px"><meeting v-if="lesson.locationtype === 1 && lesson.status <= 4" :id="lesson.id"></meeting></td></tr>
          </table>
          
           
          <h5>Notes: {{lesson.notes}}</h5>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <h3>Action</h3>
          <div class="row" style="padding-bottom: 20px">
            <div class="col-lg-3">
              <base-button
                block
                type="success"
                @click.native="onProgress(1)"
                :disabled="lesson.status > 3"
              >{{lesson.status > 3 ? "Lesson started" : "Start lesson"}}</base-button>
            </div>
            <div class="col-lg-3">{{lesson.startdatestr ? lesson.startdatestr : "Not started"}}</div>
            <div class="col-lg-3">
              <base-button
                block
                type="primary"
                @click.native="onProgress(2)"
                :disabled="lesson.status !== 4"
              >Finish lesson</base-button>
            </div>
            <div
              class="col-lg-3"
            >{{lesson.enddatestr ? lesson.enddatestr : lesson.startdatestr ? "In progress" : "Not started" }}</div>
          </div>
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <div slot="title" class="tab-header">
                <h4>Description</h4>
              </div>

              <div>
                <h5>
                  <span v-html="htmldescription" />
                </h5>
                <h5>
                  <i>{{lesson.lessonnotes}}</i>
                </h5>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <div slot="title" class="tab-header">
                <h4>Students {{students.length > 0 ? ": " + students.length : ""}}</h4>
              </div>

              <div>
                <el-table :data="students" row-key="id" header-row-class-name="thead-light">
                  <el-table-column label="Name" prop="name">
                    <template v-slot="{row}">
                      <img
                        :src="row.picture=== null ? nophoto : fileurl + row.picture"
                        class="avatar rounded-circle mr-3"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column label="Name" prop="studentname" min-width="140px" sortable></el-table-column>
                  <el-table-column width="120px" align="center" label="Present">
                    <div slot-scope="{row}">
                      <!-- <base-switch v-model="row.present" type="success" @change="onPresent(row, 2)"></base-switch> -->
                      <el-switch
                        :disabled="lesson.status !== 4"
                        v-model="row.present"
                        @change="onChange(row, 2)"
                      ></el-switch>
                    </div>
                  </el-table-column>
                  <el-table-column width="120px" align="right" label="Mark">
                    <div slot-scope="{row}" style="text-align: center">
                      <el-select v-if="!lesson.enddatestr"
                        :disabled="!row.present"
                        class="select-primary pagination-select"
                        v-model="row.mark"
                        @change="onChange(row, 3)"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in marks"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                      <span style="font-weight: bold" v-else>{{row.mark}}</span>
                    </div>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
            <el-collapse-item name="3">
              <div slot="title" class="tab-header">
                <h4>Tasks in-class {{tasks.length > 0 ? ": " + tasks.length : ""}}</h4>
              </div>

              <task-item
                v-for="task in tasks"
                :key="task.id"
                :level="task.levelname"
                :description="task.description"
                :title="task.title"
                :orderindex="task.orderindex"
                :files="task.files"
              ></task-item>
            </el-collapse-item>
            <el-collapse-item name="4">
              <div slot="title" class="tab-header">
                <h4>Homework {{homework.length > 0 ? ": " + homework.length : ""}}</h4>
              </div>

              <task-item
                v-for="hw in homework"
                :key="hw.id"
                :level="hw.levelname"
                :description="hw.description"
                :title="hw.title"
                :orderindex="hw.orderindex"
                :files="hw.files"
              ></task-item>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Collapse,
  CollapseItem,
  Select,
  Option,
  Table,
  TableColumn,
  Switch,
} from "element-ui";
import {
  GetLesson,
  Create,
  Update,
  StartFinishLesson,
  GetStudentInLesson,
  StudentInLessonAction,
  GetTaskInClass,
} from "../../../services/classes";
import { GetHomeworkShort } from "../../../services/homework";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  ShowLink,
  HtmlNewLine,
  nophoto,
  fileUrl,
} from "../../../services/helper";
import Students from "./Students";
import TaskItem from "../Courses/TaskItem";
import Meeting from "../Meeting"
export default {
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Switch.name]: Switch,
    Students,
    TaskItem,
    Loading,
    Meeting
  },
  props: {
    id: String,
    classId: String,
  },
  computed: {
    htmldescription() {
      return ShowLink(HtmlNewLine(this.lesson.description));
    },
    fileurl() {
      return fileUrl;
    },
  },
  data() {
    return {
      lesson: {},
      students: [],
      tasks: [],
      homework: [],
      isLoading: false,
      activeNames: ["1", "2", "3"],
      marks: ["0", "1", "2", "3", "4", "5"],
    };
  },
  methods: {
    getLesson() {
      this.isLoading = true;
      GetLesson(this.id).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.lesson = response.data.result;
          this.getStudents();
          this.getTaskInClass();
          this.getHomework();
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    getStudents() {
      this.isLoading = true;
      GetStudentInLesson(this.id).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.students = response.data.result;
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    getTaskInClass() {
      this.isLoading = true;
      GetTaskInClass(this.id).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.tasks = response.data.result;
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    getHomework() {
      this.isLoading = true;
      GetHomeworkShort(this.$store.state.user.id, this.id).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.homework = response.data.result;
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onProgress(type) {
      this.isLoading = true;
      StartFinishLesson(this.id, type).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.getLesson();
          if (type === 1) {
            this.getStudents();
            this.getTaskInClass();
          }
          this.notifyVue("success");
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onChange(row, type) {
      this.isLoading = true;
      let lsn = {};
      lsn.id = row.id;
      lsn.type = type;
      lsn.present = row.present;
      lsn.mark = row.mark;
      StudentInLessonAction(lsn).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.getStudents();
        } else {
          this.notifyVue("danger", response.data);
        }
      });
    },
  },
  mounted() {
    this.getLesson();
  },
};
</script>

<style lang="scss">
.tab-header {
  width: 100%;
  background-color: 	#AAFFD4;
}
.tab-header h4 {
  text-align: center;
  padding-top: 5px
}
</style>